export const teamMembers = [
  {
    id: 'oliver',
    name: "Dr. Oliver Redsch",
    role: "Head of Health Care",
    department: "Health Care",
    image: "/oliver-redsch.png",
    bio: "Dr. Oliver Redsch is a medical scientist with a PhD in Medical Science and extensive experience in international healthcare cooperation and mobility.",
    longBio: "After moving to Japan, Oliver completed his PhD at Okayama University Hospital, where his academic work was based at the Institute of Forensic Medicine with a focus on social medicine.\n\nHis research centered on suicide prevention and resulted in several publications in peer-reviewed medical journals. In parallel, he actively participated in international medical congresses, presenting on organ transplantation with particular attention to legal frameworks, ethical boundaries, and regulatory conditions in Germany and the European Union.\n\nLiving and working in Japan for more than a decade shaped both Oliver's professional and personal perspective. During this time, he developed deep expertise in international systems, intercultural communication, and sustainable cooperation.\n\nAlongside his academic work, he taught German and English at universities and educational institutions, experiences that reinforced his structured, pragmatic, and clear approach to communication.\n\nToday, as a former medical scientist and co-founder of Tri-Link Mobility, Oliver focuses on building sustainable international partnerships in healthcare. He collaborates with established partners and independent organizations on international healthcare staffing and mobility projects, including the placement of qualified nurses prepared for the German healthcare system (B1–B2 proficiency).\n\nAll of his initiatives are guided by fair-trade principles, ensuring transparency, ethical responsibility, and long-term sustainability.",
    credentials: ["M.D. Heidelberg", "PhD Medical Ethics", "Healthcare Admin Board certified"],
    social: {
      linkedin: "https://www.linkedin.com/in/dr-oliver-redsch-540890353/",
      email: "healthcare@trilink-mobility.com"
    }
  },
  {
    id: 'tal',
    name: "Tal Gibbesch",
    role: "Head of Defense and Business Immigration Sector",
    department: "Defense Sector",
    image: "/tal-gibbesch.png",
    bio: "Tal Gibbesch is an international mobility and immigration expert with a multidisciplinary background spanning international relations, security studies, and cross-border talent mobility.",
    longBio: "Before moving to Germany and founding Gibbesch Consulting GmbH, Tal built her academic and professional foundation with a BA in International Relations and American History, followed by work as a paralegal in an American law firm.\n\nThere, she was involved in investigations into funding networks of terrorist organizations, including Hamas. This experience led her to pursue an MA in Counter-Terrorism and Homeland Security, focusing on the cross-border operations and financing structures of groups such as Hezbollah.\n\nHer research was later presented at the West Point Academy to military and security experts from around the world. These years shaped Tal's ability to navigate highly complex and regulated environments, work across cultures, and translate specialized expertise into practical solutions.\n\nToday, as part of Tri-Link Global Mobility, Tal is responsible for developing the defense-industry department, as well as the business immigration department. In this role, she focuses on supporting Germany's growing need to attract international specialists and to create seamless, compliant onboarding processes within a highly regulated industry.\n\nThrough her long-standing connection to the U.S. military community in Germany, including veterans who choose to remain after retirement, Tal has gained valuable insight into the challenges of transitioning into civilian life within Germany's regulatory framework. Driven by a commitment to clarity, trust, and long-term collaboration, her goal is to build strong industry relationships and establish collaborative working models with HR and leadership teams across the German defense sector.",
    credentials: ["M.A. International Security", "SUE Clearance Expert", "Export Control certified"],
    social: {
      linkedin: "https://www.linkedin.com/in/talgibbesch/",
      email: "defense@trilink-mobility.com"
    }
  }
];

export const departmentData = {
  healthcare: {
    id: 'healthcare',
    department: "Health Care",
    path: "/health-care",
    heroImage: "https://images.unsplash.com/photo-1666887360680-9dc27a1d2753?auto=format&fit=crop&q=80&w=1600",
    featureImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=800",
    tagline: "You know it. We know it.",
    subtitle: "International Nurses for German Hospitals – Ethical & Fair Recruitment",
    intro: "Nurses are in short supply everywhere. Costs are rising beyond measure. Bureaucracy makes everything unpredictable. Some employees use clinics as a stepping stone, and loyalty is hard to plan for.\n\nWe won't sugarcoat it. We know these challenges all too well - because we have been experiencing this reality for years. And that's exactly why we decided to be different.",
    mainSection: {
      title: "Ethical Recruitment & Relocation Services",
      content: "We support hospitals in Germany in recruiting qualified international nurses and caregivers. Our candidates are professionally trained nursing staff with B1 or B2 German language certification, ready to join your healthcare team.\n\nWe provide a complete end-to-end solution, from candidate sourcing to successful integration in Germany.",
      highlights: [
        "Pre-qualified international nurses",
        "German language certified (B1/B2)",
        "Recognition and documentation support",
        "Housing and relocation assistance",
        "100% Fair Trade recruitment"
      ]
    },
    sections: [
      {
        title: "Recruitment of Qualified Nurses",
        content: "We provide hospitals with pre-screened international nurses and caregivers from trusted global partners.",
        listTitle: "Our service includes:",
        items: [
          "Candidate sourcing and qualification screening",
          "German language certification (B1/B2)",
          "Candidate profiles with CV and documentation",
          "Organization of interviews with hospital HR"
        ]
      },
      {
        title: "Recognition & Documentation",
        content: "We support the preparation of all required documents for employment in Germany.",
        listTitle: "This includes:",
        items: [
          "Coordination of the professional recognition process (Anerkennung)",
          "Documentation verification and translations",
          "Support with relevant authorities when required"
        ]
      },
      {
        title: "Relocation & Housing Support",
        content: "We assist international nurses during their move to Germany.",
        listTitle: "Services include:",
        items: [
          "Residence registration (Anmeldung)",
          "Health insurance support",
          "Housing assistance if no staff accommodation is available",
          "Guidance through administrative procedures"
        ]
      },
      {
        title: "Integration & Onboarding",
        content: "To support long-term success, we offer:",
        listTitle: "",
        items: [
          "Pre-arrival orientation",
          "Explanation of employment contracts",
          "Welcome and onboarding support"
        ]
      }
    ],
    ethicalRecruitment: {
      title: "Ethical & Fair Recruitment",
      content: "Our recruitment model follows strict Fair Trade principles.",
      items: [
        "Nurses never pay recruitment fees",
        "We work only with ethical partner organizations abroad",
        "Hospitals receive transparent candidate documentation"
      ],
      note: "Healthcare professionals typically only cover their travel to Germany, while recruitment services are provided through partnerships with healthcare institutions."
    },
    closingSection: {
      title: "Be different. Act different.",
      content: "We're not here to deliver empty phrases. We're here to ease the burden on clinics and make healthcare professionals happier.",
      values: [
        "Openness instead of marketing jargon.",
        "Transparency instead of hidden costs.",
        "Sustainability instead of short-term contracts."
      ],
      giveBack: "We give back: part of our time goes into our program for people experiencing homelessness—voluntary, unpaid, and driven by conviction.",
      inspiration: "Your dedication to healthcare inspires us to do more. To be more committed, more honest, and more human than others."
    },
    closingLine: "Let's become partners. For your clinic. For your teams. For the people you care for.",
    benefits: [
      {
        title: "Pre-qualified Nurses",
        description: "Professionally trained nursing staff ready to join your team."
      },
      {
        title: "Language Certified",
        description: "B1/B2 German language certification for all candidates."
      },
      {
        title: "Full Documentation",
        description: "Recognition and documentation support included."
      },
      {
        title: "Fair Trade",
        description: "100% ethical recruitment - nurses never pay fees."
      }
    ],
    stats: {
      placementRate: "98%",
      avgTimeToPlacement: "4-6 months",
      retentionRate: "95%",
      clientSatisfaction: "4.9/5"
    }
  },
  defense: {
    id: 'defense',
    department: "Defense Sector",
    path: "/defense-sector",
    heroImage: "https://images.unsplash.com/photo-1542434683-27a84322d59c?auto=format&fit=crop&q=80&w=1600",
    featureImage: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&q=80&w=800",
    tagline: "Accessing Global Talent for the German Defense Industry",
    subtitle: "Expertise in German immigration law, security clearance processes, and export control.",
    intro: "Tri-Link Global Mobility is a German-based consulting firm specializing in international mobility and immigration solutions for the defense industry. With deep expertise in German immigration law, security clearance processes, and export control, we support defense companies in accessing global talent while ensuring full regulatory compliance.",
    sections: [
      {
        title: "Our Defense Sector Expertise",
        content: "We support defense companies in hiring international talent for non-classified roles, ensuring full regulatory compliance while navigating the complexities of the German defense sector. Our expertise covers work visa acquisition, residence permits, and comprehensive guidance on security clearance and export control regulations.\n\nWe understand that defense sector hiring requires navigating complex regulatory frameworks. Our team provides end-to-end support, from initial candidate assessment through successful onboarding, ensuring every placement meets both your operational needs and legal requirements."
      },
      {
        title: "Comprehensive Immigration Support",
        content: "From work visa acquisition to residence permits, we handle the entire immigration process. We ensure compliance with all German regulations while streamlining the path for qualified international professionals to join your organization.\n\nOur services include document preparation, authority communication, and ongoing case management. We maintain transparent communication throughout, keeping both you and the candidate informed at every step."
      },
      {
        title: "Security Clearance Guidance",
        content: "We provide expert guidance on security clearance processes and export control regulations. Our team ensures that all placements meet the stringent requirements of the defense sector while maintaining operational efficiency.\n\nOur approach combines thorough regulatory knowledge with practical experience, helping you navigate Ü2 and SUE clearance processes, personnel reliability checks, and ITAR/EAR compliance considerations."
      },
      {
        title: "Long-Term Partnership",
        content: "We focus on building lasting relationships with defense companies, providing ongoing support and expertise as your workforce needs evolve. Our goal is to become your trusted partner in international talent acquisition.\n\nBeyond individual placements, we help you develop sustainable international hiring strategies, create internal processes for compliance, and train your HR teams on defense-specific immigration requirements."
      }
    ],
    services: [
      "Immigration strategy and planning",
      "Work visa and residence permit processing",
      "Security clearance guidance (Ü2/SUE)",
      "Export control compliance advisory",
      "Relocation and housing support",
      "Family reunification assistance",
      "Integration and onboarding programs",
      "Ongoing compliance monitoring"
    ],
    serviceGroups: ["Engineers", "Scientists", "Technical Experts"],
    closingLine: "Secure the talent you need. Navigate compliance with confidence.",
    benefits: [
      {
        title: "Security Clearance Expertise",
        description: "Guidance through Ü2 and SUE clearance processes."
      },
      {
        title: "Export Control Knowledge",
        description: "ITAR, EAR, and German export control compliance."
      },
      {
        title: "Defense Network",
        description: "Established relationships with defense sector employers."
      },
      {
        title: "Compliance Focus",
        description: "Full regulatory compliance for all placements."
      }
    ],
    stats: {
      clearanceSuccessRate: "100%",
      avgProcessingTime: "8-12 weeks",
      complianceRate: "100%",
      clientRetention: "98%"
    }
  },
  immigration: {
    id: 'immigration',
    department: "Business Immigration",
    path: "/business-immigration",
    heroImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=1600",
    featureImage: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=800",
    tagline: "Strategic Workforce Mobility Solutions",
    subtitle: "Comprehensive immigration services for businesses and professionals.",
    intro: "In today's globalized economy, workforce mobility is more than a logistical challenge, it's a strategic priority. Companies expanding into Germany need fast, compliant, and scalable immigration solutions. At Tri-Link Global Mobility, we help organizations navigate German immigration law with clarity, precision, and full regulatory alignment.",
    sections: [
      {
        title: "Strategic Immigration Consulting",
        content: "Strategic guidance: We help businesses establish compliant and efficient mobility frameworks for assigning employees to Germany. Whether you're managing a single executive relocation or building a scalable intra-company transfer program, we provide tailored immigration strategies that align with your operational goals and risk management requirements."
      },
      {
        title: "Work Visa Solutions",
        content: "Comprehensive processing: From ICT cards and EU Blue Cards to standard work permits and visas for international agreements, we manage every aspect of the work visa process. Our team ensures that each application is prepared accurately and submitted through the optimal channel, reducing processing times and minimizing rejection risk."
      },
      {
        title: "Corporate Immigration Management",
        content: "End-to-end support: We provide complete assistance for HR teams and mobility managers. This includes eligibility assessments, document preparation, authority communication, and ongoing case management. We also offer training and advisory services to help your internal teams build expertise in German immigration processes."
      },
      {
        title: "Compliance and Risk Management",
        content: "Regulatory alignment: Immigration compliance is critical in Germany. We help organizations maintain full regulatory alignment, from initial visa applications through ongoing residence compliance. Our proactive approach identifies potential issues before they become problems, protecting your business from penalties and operational disruption."
      }
    ],
    services: [
      "Strategic immigration consulting",
      "EU Blue Card processing",
      "ICT card applications",
      "Standard work permit management",
      "Document preparation and verification",
      "Authority communication and follow-up",
      "Corporate compliance advisory",
      "Employee relocation support",
      "Multi-country hiring coordination"
    ],
    serviceGroups: ["IT Professionals", "Engineers", "Executives"],
    closingLine: "Hire global talent. Comply with confidence. Integrate seamlessly.",
    benefits: [
      {
        title: "Fast Processing",
        description: "Streamlined processes for quicker visa approvals."
      },
      {
        title: "Full Compliance",
        description: "Complete regulatory alignment and risk management."
      },
      {
        title: "Corporate Solutions",
        description: "Scalable programs for enterprise clients."
      },
      {
        title: "Ongoing Support",
        description: "Continuous assistance throughout the assignment."
      }
    ],
    stats: {
      successRate: "99%",
      avgProcessingTime: "6-10 weeks",
      clientRetention: "97%",
      satisfactionRate: "4.8/5"
    }
  }
};

export const testimonials = [
  {
    quote: "Tri-Link has been instrumental in helping us recruit qualified nursing staff. Their thorough approach and ongoing support have made the entire process seamless.",
    author: "Dr. Schmidt",
    role: "Medical Director, Charité Hospital Berlin"
  },
  {
    quote: "The expertise Tri-Link brings to defense sector recruitment is unmatched. They understand the unique requirements and compliance needs perfectly.",
    author: "Klaus Weber",
    role: "HR Director, Rheinmetall AG"
  },
  {
    quote: "Working with Tri-Link has transformed our approach to international assignments. Their knowledge of German immigration law is exceptional.",
    author: "Anna Müller",
    role: "Global Mobility Manager, Siemens AG"
  }
];

export const stats = [
  { label: "Successful Placements", value: "500+", suffix: "" },
  { label: "Client Retention", value: "98", suffix: "%" },
  { label: "Processing Success", value: "99", suffix: "%" },
  { label: "Average Time to Placement", value: "4-6", suffix: " months" }
];

export const homeFeatures = [
  {
    icon: "Building2",
    title: "Industry Expertise",
    description: "Deep knowledge of Healthcare, Defense, and Business Immigration sectors with specialized teams for each industry."
  },
  {
    icon: "Shield",
    title: "Compliance First",
    description: "Full regulatory compliance in all placements, with thorough vetting and documentation processes."
  },
  {
    icon: "Users",
    title: "Global Network",
    description: "Access to qualified professionals worldwide, with established partnerships in key markets."
  },
  {
    icon: "Clock",
    title: "Efficient Process",
    description: "Streamlined recruitment and immigration processes, reducing time-to-placement significantly."
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Initial Consultation",
    description: "We assess your needs and develop a tailored recruitment strategy aligned with your business goals."
  },
  {
    step: 2,
    title: "Candidate Sourcing",
    description: "We identify and pre-screen qualified candidates from our global network who match your requirements."
  },
  {
    step: 3,
    title: "Documentation & Processing",
    description: "We handle all visa applications, work permits, and necessary documentation for a smooth transition."
  },
  {
    step: 4,
    title: "Integration Support",
    description: "We provide ongoing support for successful onboarding and long-term retention of placed professionals."
  }
];

export const companyValues = [
  {
    title: "Excellence",
    description: "We maintain the highest standards in every aspect of our work, from candidate selection to ongoing support."
  },
  {
    title: "Integrity",
    description: "We operate with complete transparency and honesty in all our relationships with clients and candidates."
  },
  {
    title: "Innovation",
    description: "We continuously improve our processes and embrace new technologies to better serve our clients."
  },
  {
    title: "Partnership",
    description: "We build lasting relationships based on trust, mutual respect, and shared success."
  }
];

export const globalPresence = [
  {
    region: "Europe",
    countries: ["Germany", "Netherlands", "Belgium", "France"],
    description: "Headquarters and primary operations"
  },
  {
    region: "Asia-Pacific",
    countries: ["India", "Philippines", "Vietnam", "Japan"],
    description: "Candidate sourcing and recruitment offices"
  },
  {
    region: "Middle East",
    countries: ["UAE", "Qatar", "Saudi Arabia"],
    description: "Strategic partnerships and candidate network"
  }
];

export const homeContent = {
  heroHeading: "Global Mobility,\nHuman Approach",
  heroText: "In today's fast-changing world, global mobility is complex and highly regulated, yet it must always be translated into a human approach.",
  aboutText: "We are a partnership of specialized relocation and immigration firms operating as one entity to deliver B2B mobility services. Together, we bring over 20 years of combined experience, shaped by different nationalities, cultures, and professional paths. Each of us has relocated internationally ourselves, including to Germany, giving us first-hand understanding of the challenges, risks, and expectations involved in cross-border mobility.",
  aboutText2: "Our professional backgrounds span multiple industries, enabling us to engage with complex environments on a practical and informed level. This perspective allows us to understand not only regulatory requirements, but also the professional contexts, compliance sensitivities, and operational realities our partners face.",
  partnershipText: "Our work is grounded in a shared operating model that brings together complementary expertise under one entity. Our partnership means being closer to regulations, to authorities, to people, and to what actually works on the ground. By combining local expertise with international experience, we design mobility solutions that are secure, compliant, and tailored, but never generic.",
  closingLine: "Real impact comes from combining strengths to create mobility solutions built for the real world.",
  sectors: [
    {
      key: "defense",
      title: "Defense",
      description: "Secure, compliance-focused mobility for sensitive and regulated roles",
      path: "/defense-sector"
    },
    {
      key: "immigration",
      title: "Business",
      description: "Efficient and dependable solutions for international and local talent",
      path: "/business-immigration"
    },
    {
      key: "healthcare",
      title: "Healthcare",
      description: "Reliable recruiting and relocation for essential specialists",
      path: "/health-care"
    }
  ]
};

export const mainHeroImage = "https://images.unsplash.com/photo-1763056682977-3fb62d7e5961?auto=format&fit=crop&q=80&w=1600";
export const officeImage = "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800";
export const buildingImage = "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=800";

export const frequentlyAskedQuestions = [
  {
    id: "faq-1",
    sector: "immigration",
    question: "What is the typical timeline for a German Blue Card?",
    answer: "For most IT professionals and engineers, the process takes 4-8 weeks from application to approval, provided all documents like university degree recognitions are in order."
  },
  {
    id: "faq-2",
    sector: "healthcare",
    question: "How do you ensure ethical recruitment in healthcare?",
    answer: "We strictly follow the WHO Global Code of Practice and do not recruit from countries on the 'Red List' unless explicitly requested through bilateral government agreements."
  },
  {
    id: "faq-3",
    sector: "immigration",
    question: "Do you handle family relocations as well?",
    answer: "Yes, our 'Family First' program includes spouse visa processing, school/kindergarten searching, and cultural orientation for all family members."
  },
  {
    id: "faq-4",
    sector: "defense",
    question: "Can you assist with security-cleared personnel?",
    answer: "Absolutely. We have a dedicated team for the defense sector that understands SUE and NATO-level clearance requirements."
  },
  {
    id: "faq-5",
    sector: "all",
    question: "What industries do you explicitly focus on?",
    answer: "We specialize in Health Care, Defense & Aerospace, and high-growth IT/Tech sectors. This focus allows us to provide deep regulatory expertise that generalist agencies cannot match."
  }
];
